import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=5f896580&scoped=true"
import script from "./Options.vue?vue&type=script&lang=js"
export * from "./Options.vue?vue&type=script&lang=js"
import style0 from "./Options.vue?vue&type=style&index=0&id=5f896580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f896580",
  null
  
)

export default component.exports